var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16 0C7.17725 0 0 7.17725 0 16C0 24.8228 7.17725 32 16 32C24.8228 32 32 24.8228 32 16C32 7.17725 24.8228 0 16 0Z",
    fill: "#fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1282 9.34177C15.3434 9.14078 15.5699 9 15.9985 9C16.427 9 16.6142 9.10373 16.8688 9.34177L21.5818 13.7168C22.0759 14.1831 22.1686 15.0695 21.6622 15.5761C21.1817 16.057 20.3398 16.1195 19.8413 15.6582L17.2839 13.2793V21.6875C17.2839 22.4123 16.7085 23 15.9985 23C15.2885 23 14.7131 22.4123 14.7131 21.6875V13.2793L12.1557 15.6582C11.6572 16.1195 10.7891 16.0828 10.3347 15.5761C9.88039 15.0695 9.87092 14.2325 10.4151 13.7168L15.1282 9.34177Z",
    fill: "#fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5d16b217a4b03849f19d699db9ce2496.svg";
export { ForwardRef as ReactComponent };